import { fieldBoxShadow, focusStyle } from '../../styles/mixins';
import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontText, hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: theme.color.greys[0],
    padding: 16,
    width: '100%',
    borderRadius: 8,
    border: `1px solid ${theme.color.greys[40]}`,
    color: theme.color.greys[80],
    font: fontText('normal', theme.fontSize.base, 24),

    '&[readonly]': {
      pointerEvents: 'none',
    },

    '&.Mui-error': {
      borderColor: theme.color.reds[100],
    },
    '&.Mui-focused': {
      boxShadow: fieldBoxShadow(theme).bs1,
      borderColor: theme.color.greys[80],
      caretColor: theme.color.oranges[50],
    },
    '&.Mui-focusVisible': {
      ...focusStyle(theme),
      borderColor: theme.color.greys[40]
    },
    '&:hover': {
      boxShadow: fieldBoxShadow(theme).bs1,
      outline: 'none',
      borderColor: theme.color.greys[80],
    },
    '&.Mui-disabled': {
      border: `1px solid ${hexToRgbA(theme.color.greys[40], 0.4)}`,
      outline: 'none',
      boxShadow: 'none',
      color: hexToRgbA(theme.color.greys[40], 0.4),
    },

    [theme.breakpoints.down('xs')]: {
      padding: '14px 16px',
      font: fontText('normal', theme.fontSize.s, 24),
    },
  },

}), { name: 'TextArea', index: StylesIndexInjections.UI_MOLECULES });
